var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 6,
  fill: "none",
  viewBox: "0 0 10 6"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#475569",
  fillRule: "evenodd",
  d: "M4.53.53c.26-.26.682-.26.942 0l4 4a.667.667 0 1 1-.943.942L5.001 1.944 1.472 5.472A.667.667 0 0 1 .53 4.53z",
  clipRule: "evenodd"
})));
export default SvgChevronUp;